import { useMemo } from "react";
import { useEncounterSummaryReport } from "@/queries/encounter/use-encounter-summary-report";
import { EncounterSumaryFormTypeEnum } from "@/services";
import { getXtenantId } from "@/utils/utils";

export interface UseNoteFormType {
  formType: EncounterSumaryFormTypeEnum | undefined;
  isResolving: boolean;
}

/** Uses the given form type, or reads it from the report so callers that only know the appointment can route the preview. */
export const useNoteFormType = (
  appointmentId: string | undefined,
  knownFormType: EncounterSumaryFormTypeEnum | undefined,
  enabled: boolean
): UseNoteFormType => {
  const shouldResolve = enabled && !knownFormType && !!appointmentId;
  const { data, isFetching, isError } = useEncounterSummaryReport({
    appointmentUuid: appointmentId,
    xTENANTID: getXtenantId(),
    enabled: shouldResolve,
  });

  return useMemo(
    () => ({
      formType: knownFormType ?? data?.formType,
      isResolving: shouldResolve && isFetching && !isError,
    }),
    [knownFormType, data?.formType, shouldResolve, isFetching, isError]
  );
};
